import { useState, useLayoutEffect, useMemo } from 'react'

/**
 * Hook to get the window size
 */
export function useWindowSize() {
	const [size, setSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	})

	useLayoutEffect(() => {
		const handleResize = () => {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight
			})
		}

		handleResize()
		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return useMemo(
		() =>
			({
				...size,
				isMobile: size.width < 768,
				isTablet: size.width >= 768 && size.width < 1024,
				isLaptop: size.width >= 1024 && size.width < 1280,
				isDesktop: size.width >= 1280
			}) as const,
		[size]
	)
}
